import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { FILE_STATS_URL } from "../ApiUrls";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class FileStatsRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  url = FILE_STATS_URL;

  body = {};

  constructor(accountId) {
    super();
    this.accountId = accountId;
  }

  getMethod = () => this.method;

  // eslint-disable-next-line class-methods-use-this
  getUrl = () => {
    const baseUrl = getCurrentUserParameters(this.url);
    return `${baseUrl}?accountId=${this.accountId}`;
  };

  getBody = () => this.body;
}
